export default "__VITE_ASSET__Dq5sOiLq__"